import React, { useEffect } from 'react';
import Header from '@components/ui/Header';
import Footer from '@components/ui/Footer';
import ContactHero from './components/ContactHero';
import QuickContactCards from './components/QuickContactCards';
import ContactForm from './components/ContactForm';
import LocationsMap from './components/LocationsMap';
import CallbackRequest from './components/CallbackRequest';
import SocialMediaLinks from './components/SocialMediaLinks';
import LiveChatWidget from './components/LiveChatWidget';

const ContactMultiChannelCommunicationHub = () => {

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Update document title
    document.title = 'Contact Us - Multi-Channel Communication Hub | Eye&U Kenya';

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        "Get in touch with Eye&U Kenya through our multi-channel communication hub. Explore various ways to contact us, including phone, email, and live chat options."
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main>
        <ContactHero />
        <QuickContactCards />
        <ContactForm />
        <LocationsMap />
        <SocialMediaLinks />
      </main>
      <Footer />
      {/* <LiveChatWidget /> --- IGNORE --- */}
    </div>
  );
};

export default ContactMultiChannelCommunicationHub;